import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Text,
  Button,
  VStack,
  Avatar,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  RadioGroup,
  Radio,
  Stack,
  Alert,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Tooltip,
  Select,
  Switch,
  FormControl,
  FormLabel,
  FormErrorMessage,
  HStack,
  NumberInput,
  NumberInputField,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon, HamburgerIcon, EditIcon, DeleteIcon } from "@chakra-ui/icons";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { API_URL, CURRENCY } from "../../../constants";
import { getAuthToken } from "../../../helpers/helpers";
import { convertPointsToMoney } from "../../../helpers/conversionHelper";

export default function Overview() {
  const history = useHistory();
  const [profiles, setProfiles] = useState([]);
  const [currentProfile, setCurrentProfile] = useState(null);
  const [roles, setRoles] = useState([]);
  const [Modif, setModif] = useState(false);
  const [currentCode_oprerateur, setcurrentCode_oprerateur] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedCodeOperateur, setSelectedCodeOperateur] = useState(null);
  const [showCode, setShowCode] = useState(false);
  const [maxProfiles, setMaxProfiles] = useState(null);
  const [pointsConfig, setPointsConfig] = useState(null);
  const [showMoney, setShowMoney] = useState(false);
  const [scheduleEnabled, setScheduleEnabled] = useState(false);
  const [schedulePeriodType, setSchedulePeriodType] = useState("one_week");
  const [customPeriodValueInput, setCustomPeriodValueInput] = useState("1");
  const [customPeriodUnit, setCustomPeriodUnit] = useState("weeks");
  const [scheduleLoading, setScheduleLoading] = useState(false);
  const [scheduleSaving, setScheduleSaving] = useState(false);
  const [scheduleErrorMessage, setScheduleErrorMessage] = useState("");
  const [scheduleNextRunAt, setScheduleNextRunAt] = useState(null);
  const token = getAuthToken();

  const {
    isOpen: isProfileModalOpen,
    onOpen: onProfileModalOpen,
    onClose: onProfileModalClose,
  } = useDisclosure();

  const {
    isOpen: isDeleteModalOpen,
    onOpen: onDeleteModalOpen,
    onClose: onDeleteModalClose,
  } = useDisclosure();

  const {
    isOpen: isResetModalOpen,
    onOpen: onResetModalOpen,
    onClose: onResetModalClose,
  } = useDisclosure();

  const {
    isOpen: isScheduleModalOpen,
    onOpen: onScheduleModalOpen,
    onClose: onScheduleModalClose,
  } = useDisclosure();

  const fetchProfiles = useCallback(async () => {
    try {
      const userId = localStorage.getItem("UserID");
      const response = await axios.get(`${API_URL}/api/profiles/${userId}`, {
        headers: {
          "x-access-token": token,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const sortedProfiles = [...response.data].sort((a, b) => {
        if (a.rank === -1) return 1;
        if (b.rank === -1) return -1;
        return a.rank - b.rank;
      });
      setProfiles(sortedProfiles);
    } catch (error) {
      console.error("Error fetching profiles:", error);
    }
  }, [token]);

  const fetchRoles = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/profile/roles`, {
        headers: {
          "x-access-token": token,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (Array.isArray(response.data)) {
        setRoles(response.data);
      } else if (response.data?.roles) {
        setRoles(response.data.roles);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  }, [token]);

  const fetchMaxProfiles = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/user/maxProfiles`, {
        headers: {
          "x-access-token": token,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const value =
        typeof response.data === "number" ? response.data : response.data?.maxProfiles;
      if (typeof value === "number") setMaxProfiles(value);
    } catch (error) {
      // If the user doesn't have maxProfiles or endpoint fails, silently ignore
      console.error("Error fetching maxProfiles:", error);
    }
  }, [token]);

  const fetchPointsConfig = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/user/points-conversion`, {
        headers: {
          'x-access-token': token,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setPointsConfig(response.data);
    } catch (error) {
      console.error("Error fetching points config:", error);
    }
  }, [token]);
  
  useEffect(() => {
    fetchProfiles();
    fetchRoles();
    fetchMaxProfiles();
    fetchPointsConfig();
  }, [fetchProfiles, fetchRoles, fetchMaxProfiles, fetchPointsConfig]);

  useEffect(() => {
    if (isScheduleModalOpen) {
      fetchScheduleConfig();
    }
  }, [isScheduleModalOpen]);

  const getAuthHeaders = () => ({
    "x-access-token": token,
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  });

  const handleOpenProfileModal = (profile = null, isModif = false) => {
    setErrorMessage("");
    setModif(isModif);
    if (profile) {
      setcurrentCode_oprerateur(profile.code_operateur);
    }
    setCurrentProfile(
      profile || {
        id: localStorage.getItem("UserID"),
        photo: "",
        nom_operateur: "",
        genre: "Homme",
        code_operateur: "",
        email: "",
        telephone: "",
        date_naissance: "",
        role: "",
      }
    );
    onProfileModalOpen();
  };

  const maskString = (str, maskChar = "*") =>
    str ? maskChar.repeat(str.length) : "";

  const handleSave = async () => {
    try {
      setErrorMessage("");
      
      // Trim spaces from code_operateur
      if (currentProfile && currentProfile.code_operateur) {
        currentProfile.code_operateur = currentProfile.code_operateur.trim();
      }
      
      if (Modif) {
        if (!currentProfile?.role) {
          setErrorMessage("Veuillez sélectionner un rôle avant de sauvegarder.");
          return;
        }
        await axios.put(
          `${API_URL}/api/update_profile`,
          {
            userId: localStorage.getItem("UserID"),
            code_operateur: currentCode_oprerateur,
            updatedData: currentProfile,
          },
          {
            headers: {
              "x-access-token": token,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      } else {
        // Include profile role only if user selected one (non-empty)
        const { role, ...restProfile } = currentProfile || {};
        const profileData = role ? { ...restProfile, role } : { ...restProfile };

        await axios.post(
          `${API_URL}/api/create_profile`,
          {
            userId: currentProfile.id,
            profileData,
          },
          {
            headers: {
              "x-access-token": token,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      }
      fetchProfiles();
      onProfileModalClose();
      setModif(false);
    } catch (error) {
      if (error?.response?.data?.duplicatedCodeOpError) {
        setErrorMessage("Ce code opérateur existe déjà.");
        return;
      }
      // Handle profile limit exceeded
      if (
        error?.response?.status === 403 &&
        error?.response?.data?.profileLimitExceededError
      ) {
        setErrorMessage(
          "Le quota de profils a été dépassé.\nVeuillez contacter l'équipe support pour mettre à niveau votre plan afin de pouvoir ajouter plus de profils."
        );
        return;
      }
      console.error("Error saving profile:", error);
    }
  };

  const confirmDelete = (codeOperateur) => {
    setSelectedCodeOperateur(codeOperateur);
    onDeleteModalOpen();
  };

  const handleDeleteConfirmed = async () => {
    if (selectedCodeOperateur) {
      try {
        await axios.delete(`${API_URL}/api/delete_profile`, {
          data: {
            userId: localStorage.getItem("UserID"),
            profileId: selectedCodeOperateur,
          },
          headers: {
            "x-access-token": token,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        fetchProfiles();
      } catch (error) {
        console.error("Error deleting profile:", error);
      }
      onDeleteModalClose();
      setSelectedCodeOperateur(null);
    }
  };

  const handleRowClick = (id) => {
    history.push("/admin/historique-vente", { id });
  };

  const handleConfirmResetPoints = async () => {
    try {
      const userId = localStorage.getItem("UserID");
      await axios.put(
        `${API_URL}/api/reinitializeProfilePoints/${userId}`,
        {},
        {
          headers: {
            "x-access-token": token,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      fetchProfiles();
      onResetModalClose();
    } catch (error) {
      console.error("Error resetting profile points:", error);
    }
  };

  const parseApiSchedulePeriod = (data) => {
    const periodCandidate = data?.period ?? data?.schedulePeriod ?? data?.resetPeriod ?? data?.config?.period ?? null;
    if (periodCandidate === null) {
      return { enabled: false, period: null };
    }

    if (typeof periodCandidate === "object") {
      const value = Number(periodCandidate.value);
      const unit = periodCandidate.unit;
      if (Number.isFinite(value) && unit) {
        return { enabled: data?.enabled ?? true, period: { value, unit } };
      }
    }

    if (typeof data?.enabled === "boolean") {
      return { enabled: data.enabled, period: null };
    }

    return { enabled: false, period: null };
  };

  const applySchedulePeriodToUi = (enabled, period) => {
    setScheduleEnabled(Boolean(enabled) && Boolean(period));

    if (!enabled || !period) {
      setSchedulePeriodType("one_week");
      return;
    }

    const value = Number(period.value);
    const unit = period.unit;

    const presetKey =
      unit === "weeks" && value === 1
        ? "one_week"
        : unit === "months" && value === 1
          ? "one_month"
          : unit === "months" && value === 3
            ? "three_months"
            : unit === "months" && value === 6
              ? "six_months"
              : unit === "months" && value === 12
                ? "one_year"
                : null;

    if (presetKey) {
      setSchedulePeriodType(presetKey);
      return;
    }

    setSchedulePeriodType("custom");
    setCustomPeriodValueInput(String(value));
    setCustomPeriodUnit(unit === "months" ? "months" : "weeks");
  };

  const fetchScheduleConfig = async () => {
    try {
      setScheduleErrorMessage("");
      setScheduleLoading(true);
      setScheduleNextRunAt(null);
      const response = await axios.get(
        `${API_URL}/api/profilePointsResetSchedule`,
        { headers: getAuthHeaders() }
      );

      const parsed = parseApiSchedulePeriod(response.data);
      applySchedulePeriodToUi(parsed.enabled, parsed.period);

      const nextRunAtCandidate =
        response.data?.nextRunAt ??
        response.data?.config?.nextRunAt ??
        response.data?.schedule?.nextRunAt ??
        null;
      setScheduleNextRunAt(nextRunAtCandidate);
    } catch (error) {
      setScheduleErrorMessage("Impossible de charger la configuration.");
      console.error("Error fetching schedule config:", error);
    } finally {
      setScheduleLoading(false);
    }
  };

  const formatNextRunAt = (value) => {
    if (!value) return null;
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);
    return d.toLocaleString("fr-FR");
  };

  const isCustomPeriodValueValid = () => {
    if (!scheduleEnabled || schedulePeriodType !== "custom") return true;
    if (customPeriodValueInput === "") return false;
    const n = Number(customPeriodValueInput);
    return Number.isFinite(n) && Number.isInteger(n) && n >= 1 && n <= 36;
  };

  const computeSelectedSchedulePeriod = () => {
    if (!scheduleEnabled) return null;

    if (schedulePeriodType === "custom") {
      const safeValue = Number(customPeriodValueInput);
      return {
        value: safeValue,
        unit: customPeriodUnit,
      };
    }

    const presetMap = {
      one_week: { value: 1, unit: "weeks" },
      one_month: { value: 1, unit: "months" },
      three_months: { value: 3, unit: "months" },
      six_months: { value: 6, unit: "months" },
      one_year: { value: 12, unit: "months" },
    };

    return presetMap[schedulePeriodType] || { value: 1, unit: "weeks" };
  };

  const handleSaveSchedule = async () => {
    try {
      setScheduleErrorMessage("");
      setScheduleSaving(true);
      const period = computeSelectedSchedulePeriod();

      const response = await axios.put(
        `${API_URL}/api/profilePointsResetSchedule`,
        { period },
        { headers: getAuthHeaders() }
      );

      console.log("scheduled_points_reset_period", period);
      console.log("scheduled_points_reset_period_response", response.data);
      onScheduleModalClose();
    } catch (error) {
      setScheduleErrorMessage("Impossible d'enregistrer la configuration.");
      console.error("Error saving schedule config:", error);
    } finally {
      setScheduleSaving(false);
    }
  };

  return (
    <Box pt={{ base: "140px", md: "80px", xl: "80px" }}>
      {/* Profiles Section */}
      <Box
        maxWidth={{ base: "100%", lg: "100%" }}
        mx="auto"
        overflowX="auto"
        p={4}
        boxShadow="md"
        borderRadius="lg"
      >
        <Text fontSize="xl" fontWeight="bold" mb={4} textAlign="center">
          Liste des Profils
        </Text>
        {/* Controls row: Add button (left) and remaining profiles (right) */}
        <Flex align="center" justify="space-between" mb={4}>
          <Button colorScheme="teal" onClick={() => handleOpenProfileModal()}>
            Ajouter un nouveau profil
          </Button>
          {maxProfiles && (
            (() => {
              const activeProfilesCount = profiles.filter((p) => p.isDeleted === false).length;
              const diff = maxProfiles - activeProfilesCount;
              const remaining = Math.max(0, diff);
              return (
                <Text 
                  fontSize="sm" 
                  textAlign="right" 
                  color={remaining === 0 ? "red" : remaining === 1 ? "orange" : "green"}
                >
                  Profils restants: {" "}
                  <Box
                    as="span"
                    fontWeight="bold"
                  >
                    {remaining} / {Math.max(maxProfiles, activeProfilesCount)}
                  </Box>
                </Text>
              );
            })()
          )}
        </Flex>
        <Table variant="simple" size="md">
          <Thead>
            <Tr>
      <Th>Rang</Th>  
              <Th>Photo</Th>
              <Th>Nom de l’opérateur</Th>
              <Th>Genre</Th>
              <Th>
                Code opérateur
                <IconButton
                  size="sm"
                  ml={2}
                  aria-label={showCode ? "Masquer le code" : "Afficher le code"}
                  icon={showCode ? <ViewOffIcon /> : <ViewIcon />}
                  onClick={() => setShowCode(!showCode)}
                />
              </Th>
              <Th>Email</Th>
              <Th>Numéro téléphone</Th>
              <Th>Date de naissance</Th>
              <Th>
                Score
                {pointsConfig && pointsConfig.enabled && (
                  <Box display="inline-block" ml={2}>
                      <Text fontSize="xs" display="inline" mr={2}>Pts/Argent</Text>
                    <Switch 
                      size="sm" 
                      isChecked={showMoney} 
                      onChange={(e) => setShowMoney(e.target.checked)} 
                      colorScheme="teal"
                    />
                  </Box>
                )}
              </Th>
              <Th>
                Actions
                <Menu>
                  <Tooltip
                    label="Plus d'actions"
                    hasArrow
                    placement="top"
                    bg="rgba(0, 0, 0, 0.6)"
                    fontSize="xs"
                  >
                    <MenuButton
                      as={IconButton}
                      size="sm"
                      aria-label="Options"
                      icon={<HamburgerIcon />}
                      variant="ghost"
                      ml={2}
                    />
                  </Tooltip>
                  <MenuList>
                    <MenuItem onClick={onResetModalOpen}>
                      Réinitialiser les points
                    </MenuItem>
                    <MenuItem onClick={onScheduleModalOpen}>
                      Planifier la réinitialisation périodique des points
                    </MenuItem>
                  </MenuList>
                </Menu>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {profiles.map((profile) => (
              <Tr
                key={profile._id}
                _hover={{ bg: "gray.100" }}
                cursor="pointer"
                onClick={() => handleRowClick(profile._id)}
              >
        <Td>
          {profile.rank === -1 ? (
            <Text color="gray.500">Supprimé</Text>
          ) : (
            <Box
              display="inline-flex"
              alignItems="center"
              justifyContent="center"
              w="24px"
              h="24px"
              borderRadius="full"
              bg={profile.rank <= 3 ? "gold" : "gray.100"}
              color={profile.rank <= 3 ? "black" : "gray.700"}
              fontWeight="bold"
            >
              {profile.rank}
            </Box>
          )}
        </Td>
                <Td>
                  <Avatar src={profile.photo} name={profile.nom_operateur} />
                </Td>
                <Td>{profile.nom_operateur}</Td>
                <Td>{profile.genre}</Td>
                <Td>
                  {showCode
                    ? profile.code_operateur
                    : maskString(profile.code_operateur)}
                </Td>
                <Td>{profile.email || "—"}</Td>
                <Td>{profile.telephone || "—"}</Td>
                <Td>
                  {profile.date_naissance
                    ? new Date(profile.date_naissance)
                        .toISOString()
                        .split("T")[0]
                    : "—"}
                </Td>
                <Td>
                  {showMoney && pointsConfig?.enabled
                    ? `${convertPointsToMoney(profile.points, pointsConfig.conversionRate)} ${CURRENCY.code}`
                    : `${profile.points || 0} pts`
                  }
                </Td>
                <Td>
                  <Button
                    size="sm"
                    colorScheme="blue"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenProfileModal(profile, true);
                    }}
                    leftIcon={<EditIcon />}
                  >
                    Modifier
                  </Button>
                  <Button
                    size="sm"
                    colorScheme="red"
                    ml={2}
                    onClick={(e) => {
                      e.stopPropagation();
                      confirmDelete(profile._id);
                    }}
                    leftIcon={<DeleteIcon />}
                  >
                    Supprimer
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={isDeleteModalOpen} onClose={onDeleteModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirmation</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Êtes-vous sûr de vouloir supprimer cet opérateur ?</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" onClick={handleDeleteConfirmed}>
              Oui, supprimer
            </Button>
            <Button variant="ghost" ml={3} onClick={onDeleteModalClose}>
              Annuler
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Reset Points Confirmation Modal */}
      <Modal isOpen={isResetModalOpen} onClose={onResetModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Réinitialiser les points</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Êtes-vous sûr de vouloir réinitialiser les points ?</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" onClick={handleConfirmResetPoints}>
              Oui, réinitialiser
            </Button>
            <Button variant="ghost" ml={3} onClick={onResetModalClose}>
              Annuler
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Schedule Reset Modal */}
      <Modal isOpen={isScheduleModalOpen} onClose={onScheduleModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Planifier la réinitialisation</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing="14px" align="stretch">
              {scheduleErrorMessage && (
                <Text color="red.500" fontSize="sm">
                  {scheduleErrorMessage}
                </Text>
              )}

              {scheduleNextRunAt && (
                <Text fontSize="sm" color="gray.600">
                  Prochaine réinitialisation prévue : <b>{formatNextRunAt(scheduleNextRunAt)}</b>
                </Text>
              )}

              <FormControl display="flex" alignItems="center" justifyContent="space-between">
                <FormLabel mb="0">Activer</FormLabel>
                <Switch
                  isChecked={scheduleEnabled}
                  isDisabled={scheduleLoading}
                  onChange={(e) => {
                    const enabled = e.target.checked;
                    setScheduleEnabled(enabled);
                    if (!enabled) {
                      setSchedulePeriodType("one_week");
                    }
                  }}
                />
              </FormControl>

              <FormControl isDisabled={!scheduleEnabled || scheduleLoading}>
                <FormLabel>Période</FormLabel>
                <Select
                  value={schedulePeriodType}
                  onChange={(e) => setSchedulePeriodType(e.target.value)}
                >
                  <option value="one_week">Une semaine</option>
                  <option value="one_month">Un mois</option>
                  <option value="three_months">3 mois</option>
                  <option value="six_months">6 mois</option>
                  <option value="one_year">Un an</option>
                  <option value="custom">Personnalisée</option>
                </Select>
              </FormControl>

              {scheduleEnabled && !scheduleLoading && schedulePeriodType === "custom" && (
                <HStack spacing="10px" align="flex-end">
                  <FormControl isInvalid={!isCustomPeriodValueValid()}>
                    <FormLabel>Valeur</FormLabel>
                    <NumberInput
                      keepWithinRange={false}
                      clampValueOnBlur={false}
                      value={customPeriodValueInput}
                      onChange={(valueString) => setCustomPeriodValueInput(valueString)}
                    >
                      <NumberInputField />
                    </NumberInput>
                    <FormErrorMessage>
                      Valeur doit être entre 1 et 36.
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl>
                    <FormLabel>Unité</FormLabel>
                    <Select
                      value={customPeriodUnit}
                      onChange={(e) => setCustomPeriodUnit(e.target.value)}
                    >
                      <option value="weeks">Semaines</option>
                      <option value="months">Mois</option>
                    </Select>
                  </FormControl>
                </HStack>
              )}

              {!scheduleEnabled && (
                <Text fontSize="sm" color="gray.600">
                  Fonction désactivée : la période sera enregistrée comme <b>null</b>.
                </Text>
              )}
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              onClick={handleSaveSchedule}
              mr="3"
              isLoading={scheduleSaving}
              loadingText="Sauvegarde"
              isDisabled={!isCustomPeriodValueValid()}
            >
              Sauvegarder
            </Button>
            <Button variant="ghost" onClick={onScheduleModalClose} isDisabled={scheduleSaving}>
              Annuler
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Add/Edit Profile Modal */}
      <Modal isOpen={isProfileModalOpen} onClose={onProfileModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {Modif ? "Modifier Profil" : "Ajouter un Profil"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing="10px">
              {errorMessage && (
                <Alert
                  status="error"
                  bg="red"
                  color="white"
                  borderRadius="md"
                  whiteSpace="pre-line"
                >
                  {errorMessage}
                </Alert>
              )}
              <Input
                placeholder="Nom de l’opérateur (Obligatoire)"
                value={currentProfile?.nom_operateur || ""}
                onChange={(e) =>
                  setCurrentProfile({
                    ...currentProfile,
                    nom_operateur: e.target.value,
                  })
                }
              />
              <RadioGroup
                value={currentProfile?.genre || "Homme"}
                onChange={(value) =>
                  setCurrentProfile({ ...currentProfile, genre: value })
                }
              >
                <Stack direction="row">
                  <Radio value="Homme">Homme</Radio>
                  <Radio value="Femme">Femme</Radio>
                </Stack>
              </RadioGroup>
              <Input
                placeholder="Code opérateur (Obligatoire)"
                value={currentProfile?.code_operateur || ""}
                onChange={(e) =>
                  setCurrentProfile({
                    ...currentProfile,
                    code_operateur: e.target.value,
                  })
                }
              />
              <Input
                placeholder="Adresse email (Facultatif)"
                value={currentProfile?.email || ""}
                onChange={(e) =>
                  setCurrentProfile({
                    ...currentProfile,
                    email: e.target.value,
                  })
                }
              />
              <Input
                placeholder="Numéro téléphone (Facultatif)"
                value={currentProfile?.telephone || ""}
                onChange={(e) =>
                  setCurrentProfile({
                    ...currentProfile,
                    telephone: e.target.value,
                  })
                }
              />
              <Text fontSize="sm" color="gray.500" pr={200}>
                Date de naissance (Facultatif)
              </Text>
              <Input
                type="date"
                placeholder="Date de naissance (Facultatif)"
                value={currentProfile?.date_naissance || ""}
                onChange={(e) =>
                  setCurrentProfile({
                    ...currentProfile,
                    date_naissance: e.target.value,
                  })
                }
                _placeholder={{ color: "gray.500" }}
              />
              <Input
                placeholder="URL de la photo (Facultatif)"
                value={currentProfile?.photo || ""}
                onChange={(e) =>
                  setCurrentProfile({
                    ...currentProfile,
                    photo: e.target.value,
                  })
                }
              />
              <Box w="100%">
                <Text fontSize="sm" color="gray.500" mb={1}>
                  Rôle (Sélectionnez un rôle)
                </Text>
                <Box
                  borderWidth="1px"
                  borderRadius="md"
                  maxH="140px"
                  overflowY="auto"
                  p={1}
                >
                  {roles.length === 0 && (
                    <Text fontSize="xs" color="gray.400" px={2} py={1}>
                      Chargement des rôles...
                    </Text>
                  )}
                  {roles.map((r, idx) => {
                    const value = typeof r === "string" ? r : r?.name || r?.label || `role-${idx}`;
                    const isSelected = currentProfile?.role === value;
                    return (
                      <Box
                        key={value}
                        px={3}
                        py={2}
                        mb={1}
                        cursor="pointer"
                        borderRadius="md"
                        bg={isSelected ? "blue.500" : "gray.50"}
                        color={isSelected ? "white" : "gray.700"}
                        _hover={{ bg: isSelected ? "blue.600" : "gray.100" }}
                        fontSize="sm"
                        // Toggle selection: clicking the selected role unselects it
                        onClick={() =>
                          setCurrentProfile({
                            ...currentProfile,
                            role: isSelected ? "" : value,
                          })
                        }
                      >
                        {value}
                      </Box>
                    );
                  })}
                </Box>
                <Text mt={1} fontSize="xs" color="gray.600">
                  {currentProfile?.role ? `Rôle sélectionné: ${currentProfile.role}` : "Aucun rôle sélectionné"}
                </Text>
              </Box>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={handleSave} mr="3">
              Sauvegarder
            </Button>
            <Button onClick={onProfileModalClose}>Annuler</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}
